module.exports = [
  'Toddlers (under 6)',
  'Children (6-12)',
  'Teenagers (12-18)',
  'Young Adults (18-24)',
  'Adults (24+)',
  'Elders (65+)',
];
